module.exports = "/images/arrow-right.svg?a265b51ffdf0b0d6338bfca65abc4ead";